<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center">
    <div class="bg-white w-full rounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <router-link :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3" to="/regroupements">
            <i class="material-icons mx-2">chevron_left</i>
          </router-link>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500 ">New regroupement</div>
          <div v-else class="text-2xl font-bold text-blue-500 ">Edit regroupement</div>
        </div>
      </div>
        <div class="bg-white rounded-lg p-6 pt-2">
          <div class="grid lg:grid-cols-2 gap-6">
            <div class="border hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                          <label for="name" class="bg-white text-gray-700 px-1">Name <span :class="$colors.required">*</span></label>
                      </p>
                  </div>
                  <p>
                    <input
                    id="name"
                    placeholder="Warehouse name"
                    tabindex="0"
                    type="text"
                    v-model="formData.name"
                    class="py-2 text-xs px-2 outline-none block h-full w-full"/>
                  </p>
            </div>
            <div class="border hover:border-blue-500  focus-within:border-blue-500 focus-within:text-blue-500  transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="Countries" class="bg-white text-gray-700 px-1"> Warhouses *</label>
                      </p>
                    </div>    
                    <p>
                      <v-select label="countryName" v-model="formData.warehouses" :options="warehouses" multiple>
                              <template slot="option" slot-scope="option">
                                  <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                                  {{ option.countryName }} 
                              </template>
                        </v-select>
                    </p>    
            </div>
          </div>
   
         
          <div class="mt-6 pt-3 flex justify-center">
              <button
                @click="save"
                class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-600  hover:shadow-inner hover:bg-blue-700  transition-all duration-300"
              >
                Save
              </button>
            </div>
     
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {
        name: "",
        warehouses:[]
      },
      warehouses:[],
      options: this.$countries,
    };
  },
  async mounted() {
   // await this.getWarehouses();
    await this.dataToEdit();
  },
  methods: {
     async getWarehouses(){
        this.warehouses=this.currentUser.warehouses;
        // const filter = {limit:1000};
        // const res = await this.$server.search("warehouses",filter);
        // if (res.content.results) this.warehouses = res.content.results;
        // else this.warehouses = [];
    }, 
    async save() {
      if (this.formData._id) {
          if(this.checkData()) {
            const data = await this.$server.update("regroupements", this.formData);
            if (data && data._id) alert("warehouse updated", "success");
          }else alert(data||"required field", "warning");
        
      } else {
          if (this.checkData()) {
            // console.log('this.formData-----',this.formData)
            // return false
             const data = await this.$server.create("regroupements", this.formData);
             if (data && data._id) {
                 alert("regroupements created", "success");
                 this.formData={name: "",warehouses:[]}
             }else alert(data, "warning");
          }else alert('required field', "warning");
      }
    },
    checkData() {
      if (
        this.formData.name &&
        this.formData.warehouses && this.formData.warehouses.length>0
      )return true;
      else return false;
    },
    getElementInArray(data,value){
        var result  = data.filter(function(o){
            let whar=o._id.toString();
            return whar == value.toString();
        } );
        return result? result[0] : null; // or undefined
    },
    async dataToEdit() {
      this.warehouses= this.currentUser.warehouses;
      if (this.$route.params.id) {
        const editData = await this.$server.get("regroupements", {id: this.$route.params.id,});
        this.formData = editData.content;
        let index = 0;
          for(let warehouse  of  this.formData.warehouses) { 
            const wareh=this.getElementInArray(this.warehouses, warehouse)
              this.formData.warehouses[index]=wareh;
            index ++;
          }
      }
    },
    /*************************************************************** */
    /**************************************************************/
  },
};
</script>

<style scoped>

</style>